import i18n from "i18next"
import detector from "i18next-browser-languagedetector"
import resourcesToBackend from "i18next-resources-to-backend"
import { initReactI18next } from "react-i18next"

import { formatDisplayNumber } from "@/utils/formatNumber"

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(
    resourcesToBackend((language) => {
      const map = {
        en: import("./en.json"),
        "zh-CN": import("./zh-CN.json"),
        "zh-TW": import("./zh-TW.json"),
        cs: import("./cs.json"),
        da: import("./da.json"),
        nl: import("./nl.json"),
        fi: import("./fi.json"),
        fr: import("./fr.json"),
        de: import("./de.json"),
        it: import("./it.json"),
        ja: import("./ja.json"),
        ko: import("./ko.json"),
        no: import("./no.json"),
        nb: import("./nb.json"),
        pl: import("./pl.json"),
        "pt-BR": import("./pt-BR.json"),
        "pt-PT": import("./pt-PT.json"),
        es: import("./es.json"),
        sv: import("./sv.json"),
        th: import("./th.json"),
        tr: import("./tr.json"),
      }
      return map[language]
    }),
  )
  .init({
    saveMissing: true,
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    // resources: getResource(),
    lng: "en", // if you're using a language detector, do not define the lng option
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
      // 自定义格式化函数，将数字转换为本地格式
      format: (value, format, lng) => {
        if (format === "number" && typeof value === "number") {
          return formatDisplayNumber(value)
        }
        return value
      },
    },
  })

export function setLocal(local) {
  i18n.changeLanguage(local)
}

export function getValidLanguage(local) {
  // 检查local是否在langList中
  const isValidLanguage = langList.some((lang) => lang.value === local)

  if (!isValidLanguage) {
    // 如果local不在列表中，尝试获取语言前缀
    const languagePrefix = local?.split("-")[0]
    const hasPrefixLanguage = langList.find((lang) =>
      lang.value.startsWith(languagePrefix),
    )?.value

    if (hasPrefixLanguage) {
      local = languagePrefix
    } else {
      // 如果前缀也不在列表中，设置为英语
      local = "en"
    }
  }
  return local
}

export const langList = [
  { label: "简体中文", value: "zh-CN" },
  { label: "繁體中文", value: "zh-TW" },
  { label: "Čeština", value: "cs" },
  { label: "Dansk", value: "da" },
  { label: "Nederlands", value: "nl" },
  { label: "English", value: "en" },
  { label: "Suomi", value: "fi" },
  { label: "Français", value: "fr" },
  { label: "Deutsch", value: "de" },
  { label: "Italiano", value: "it" },
  { label: "日本語", value: "ja" },
  { label: "한국어", value: "ko" },
  { label: "Norsk", value: "no" },
  { label: "Norsk bokmål", value: "nb" },
  { label: "Polski", value: "pl" },
  { label: "Português (Brasil)", value: "pt-BR" },
  { label: "Português (Portugal)", value: "pt-PT" },
  { label: "Español", value: "es" },
  { label: "Svenska", value: "sv" },
  { label: "ไทย", value: "th" },
  { label: "Türkçe", value: "tr" },
]

// export function getResource() {
//   const resource: { [key: string]: any } = {}
//   const modules = import.meta.glob("./*.json", { eager: true })

//   Object.entries(modules).forEach(([path, data]) => {
//     const matcher = path.match(/\/(.+)\.json/)
//     if (matcher?.[1]) {
//       resource[matcher[1]] = {
//         translation: data,
//       }
//     }
//   })
//   return resource
// }
